import React from 'react';
import { ImageUpload as ImageUploadNew } from './ImageUpload';
import { convertOldImageUploadProps } from './converter.old';
import type { OldImageUploadProps } from './converter.old';
export type ImageUploadProps = OldImageUploadProps;
export const ImageUpload = (props: ImageUploadProps) => <ImageUploadNew {...convertOldImageUploadProps(props)} />;
